import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { SharedModule } from '@app/shared';
import { LinqFormsModule } from '@app/shared/forms/forms.module';
import { SetupBudgetImportComponent, SetupBudgetImportConfirmModalComponent } from '.';

@NgModule({
    imports: [CommonModule, SharedModule, LinqFormsModule, FormlyMaterialModule, SetupBudgetImportComponent, SetupBudgetImportConfirmModalComponent],
    providers: [],
})
export class ManageAccountsModule {}
